import {
  Component,
  OnInit,
  OnDestroy,
  Output,
  EventEmitter,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  LocationService,
  LocationCoordinates,
} from '../../../core/services/location.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-location-alert',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './location-alert.component.html',
  styleUrls: ['./location-alert.component.scss'],
})
export class LocationAlertComponent implements OnInit, OnDestroy {
  @Output() locationActivatedChange = new EventEmitter<LocationCoordinates>();

  locationActivated: boolean = false;
  private destroy$ = new Subject<void>();

  constructor(private locationService: LocationService) {}

  ngOnInit(): void {
    // Vérifier l'état initial
    this.locationActivated = this.locationService.isLocationActivated();

    // S'abonner aux changements de localisation
    this.locationService.location$
      .pipe(takeUntil(this.destroy$))
      .subscribe((location) => {
        this.locationActivated = location !== null;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onActivateClick(): void {
    this.locationService
      .activateLocation()
      .then((coordinates: LocationCoordinates | null) => {
        if (coordinates) {
          // Emit coordinates to parent
          this.locationActivatedChange.emit(coordinates);
        }
      });
  }
}
